import Repository from './repository'

const resource = '/cliente'

export default {

  getId (id) {
    return Repository.get(`${resource}/${id}`)
  },
  getList (pesquisa) {
    return Repository.get(`${resource}/getlistacliente/${pesquisa}`)
  },
  Update (data) {
    return Repository.post(`${resource}/editar/`, data)
  },
  Delete (data) {
    return Repository.post(`${resource}/excluir/`, data)
  },
  Save (data) {
    return Repository.post(`${resource}/Salvar/`, data)
  },
}
